<template>
  <div style="max-width:100%; margin: auto;height:calc(100vh - 56px)">
    <div class="page-f">

      <div class="col-12" style="max-width: 100%;padding: 0;position: relative;">
        <div id="search_map" style="max-width: 100%;"></div>
        <div id="map" style="width: 100%;height: 100%"></div>
        <span class="location-btn"
          :class="{ 'LocS1': step1 == 10, 'LocS2': step1 == 2, 'LocS3': step1 == 0, 'LocS4': step1 == 3, 'LocS5': step1 == 0 && markerThree != '' }"
          @click="get_loc('', '', 'f')">
          <font-awesome-icon :icon="['fas', 'location-crosshairs']" />
        </span>

        <span id="ClosePage4" class="back-btn d-none" @click="ClosePage4()">
          <v-icon size="35" color="">mdi-arrow-right</v-icon>
        </span>

        <div class="address-inputs">
          <div v-if="step == 1" class="text-center">
            <div style="cursor: pointer" class="d-flex flex-column justify-space-between align-center">
              <div style="width: 90%; margin: auto">
                <div :style="BtnStyle" @click="OpenModel1" class="d-flex  justify-space-between bg-white"
                  style="font-size:1rem; width: 100%; margin: auto; margin-bottom: 20px !important; border: 2px solid #eee; height:45px; padding:6px; border-radius:5px;">
                  <h4 v-if="markerOne == ''" style="font-weight: 400">کجا هستید ؟</h4>
                  <h4 v-if="markerOne != ''"
                    style="font-weight: 400; color: green;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    {{ markerOne.name }}</h4>
                  <img src="/app/img/SearchLogo.png" alt="SearchLogo" style="height: 22px; width: 22px">
                </div>
              </div>
              <!--          <v-btn @click="NextStep"-->
              <!--            style="font-size:1rem; width: 90%; margin: auto; border-radius: 5px; color: white; background-color: #00bc6e; padding:10px; height:45px; ">تایید-->
              <!--            مبدا</v-btn>-->
            </div>
            <br>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <!--            <input v-model="SearchList" placeholder="کجا هستی ؟" class="TopInputShowType" type="text">-->
                <v-text-field v-model="SearchList" class="mx-5 " label="کجا هستید؟"></v-text-field>


                <div class="ListShowToUser">
                  <!--              result list title-->
                  <v-row v-if="list.length > 0" class="mt-1 ">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>

                  <!--              result list-->
                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet = false">
                      <div @click="BtnSendData(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">

                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>


                  <!--              history title-->
                  <v-row class="mt-1 ">
                    <span v-if="list.length == 0" class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet = false">
                        <div @click="BtnSendData(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>

                </div>
              </v-sheet>
            </v-bottom-sheet>
          </div>
          <div v-if="step == 2" class="text-center">
            <div style="width: 90%; margin: auto">
              <div :style="BtnStyle" @click="OpenModel1" class="d-flex  justify-space-between bg-white"
                style="font-size:1rem; width: 100%; margin: auto; margin-bottom: 20px !important; border: 2px solid #eee; height:45px; padding:6px; border-radius:5px;">
                <h4 v-if="markerOne == ''" style="font-weight: 400">کجا هستید ؟</h4>
                <h4 v-if="markerOne != ''"
                  style="font-weight: 400; color: green;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  {{ markerOne.name }}</h4>
                <img src="/app/img/SearchLogo.png" alt="SearchLogo" style="height: 22px; width: 22px">
              </div>
            </div>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <v-text-field v-model="SearchList" class="mx-5" label="کجا هستید؟"></v-text-field>

                <div class="ListShowToUser">
                  <v-row class="mt-1 " v-if="list.length > 0">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>
                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet = false">
                      <div @click="BtnSendData(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">
                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                  <!--              history title-->
                  <v-row v-if="list.length == 0" class="mt-1 ">
                    <span class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet = false">
                        <div @click="BtnSendData(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>

            <div style="cursor: pointer" class="d-flex flex-column justify-space-between align-center">
              <div style="width: 90%; margin: auto">
                <div :style="BtnStyle1" @click="OpenModel2" class="d-flex  justify-space-between bg-white"
                  style="font-size:1rem; width: 100%; margin: auto; margin-bottom: 20px !important; border: 2px solid #eee; height:45px; padding:6px; border-radius:5px;">
                  <h4 v-if="markerTwo == ''" style="font-weight: 400">کجا می روید؟</h4>
                  <h4 v-if="markerTwo != ''"
                    style="font-weight: 400; color: green;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    {{ markerTwo.name }}</h4>
                  <img src="/app/img/SearchLogo.png" alt="SearchLogo" style="height: 22px; width: 22px">
                </div>
              </div>
              <!--          <v-btn @click="NextStep2"-->
              <!--            style="font-size:1rem; width: 90%; margin: auto; border-radius: 5px; color: white; background-color: #00bc6e; padding:10px; height:45px; ">تایید-->
              <!--            مقصد</v-btn>-->
            </div>
            <br>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet1">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet1 = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <v-text-field v-model="SearchList" class="mx-5" label="کجا می روید؟"></v-text-field>

                <div class="ListShowToUser">
                  <v-row class="mt-1 " v-if="list.length > 0">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>
                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet1 = false">
                      <div @click="BtnSendData2(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">
                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>

                  <!--              history title-->
                  <v-row class="mt-1 " v-if="list.length == 0">
                    <span class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet1 = false">
                        <div @click="BtnSendData2(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>
          </div>
          <div v-if="step == 3" class="text-center ">
            <div @click="OpenModel1" class="bg-white"
              style="height: 20px;  display: grid; grid-template-columns: 75% 25% ; justify-content: space-between;width:90%; margin: auto; box-shadow: 0 0 2px rgba(0,0,0,.2); height:45px; padding:10px; border-radius:10px; margin-bottom:15px !important;">
              <p v-if="markerOne == ''" style="text-align: right;color: green; font-size:14px;">کجا هستید ؟</p>
              <p v-if="markerOne != ''"
                style="height: 20px;text-align: right;color: green; font-size:14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                {{ markerOne.name }}</p>
              <!-- <h5 class="green--text">تغییر مبدا</h5> -->
              <span style="color: red; font-size: .8rem">تغییر مبدا</span>
            </div>
            <div @click="OpenModel2" class="bg-white"
              style="display: grid; grid-template-columns: 75% 25% ; justify-content: space-between;width:90%; margin: auto; box-shadow: 0 0 2px rgba(0,0,0,.2); min-height:45px; padding:10px; padding-bottom: 0 !important; border-radius:10px; margin-bottom:15px !important;">
              <p v-if="markerTwo == ''" style="text-align: right;color: green; font-size:14px;">کجا میخوای بری ؟</p>
              <p v-if="markerTwo != ''"
                style="text-align: right;color: green; font-size:14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                {{ markerTwo.name }}</p>

              <span style="color: red; font-size: .8rem">تغییر مقصد</span>
            </div>
            <div v-if="Lastmarker" @click="OpenModel3" class="bg-white"
              style="display: grid; grid-template-columns: 70% 30% ; justify-content: space-between;width:90%; margin: auto; box-shadow: 0 0 2px rgba(0,0,0,.2); min-height:45px; padding:10px; padding-bottom: 0 !important; border-radius:10px; margin-bottom:15px !important;">
              <p style="color: green; font-size:14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                {{ markerThree.name }}</p>

              <span style="color: red; font-size: .8rem">تغییر مقصد دوم</span>
            </div>

            <v-bottom-sheet style="z-index: 1050" v-model="sheet">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <v-text-field v-model="SearchList" class="mx-5" label="کجا هستید؟"></v-text-field>

                <div class="ListShowToUser">
                  <v-row class="mt-1 " v-if="list.length > 0">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>
                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet = false">
                      <div @click="BtnSendData(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">
                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                  <!--              history title-->
                  <v-row class="mt-1 " v-if="list.length == 0">
                    <span class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet = false">
                        <div @click="BtnSendData(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet1">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet1 = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <v-text-field v-model="SearchList" class="mx-5" label="کجا می روید؟"></v-text-field>

                <div class="ListShowToUser">
                  <v-row class="mt-1 " v-if="list.length > 0">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>
                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet1 = false">
                      <div @click="BtnSendData2(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">
                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>

                  <!--              history title-->
                  <v-row class="mt-1 " v-if="list.length == 0">
                    <span class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet1 = false">
                        <div @click="BtnSendData2(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet2">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet2 = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <v-text-field v-model="SearchList" class="mx-5" label="مقصد دومتون کجاست؟"></v-text-field>

                <div class="ListShowToUser">
                  <v-row class="mt-1 " v-if="list.length > 0">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>

                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet2 = false">
                      <div @click="BtnSendData3(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">
                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>

                  <!--              history title-->
                  <v-row class="mt-1 " v-if="list.length == 0">
                    <span class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet2 = false">
                        <div @click="BtnSendData3(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>

                </div>
              </v-sheet>
            </v-bottom-sheet>

            <div style="padding-bottom: 20px">
              <div class="divClassDivCloseButton1">
                <v-btn @click="BtnShowIt3" style="
        color: white;
        background-color: #08d474;
        padding: 25px;
        font-size: 1rem;
        border-radius: 10px;
        margin-left: 10px;
      ">
                  درخواست خودرو
                </v-btn>
                <v-btn @click="BtnShowIt4"
                  style=" color:black; background-color: #fff; padding:25px; border-radius:10px; ">
                  <img src="@/assets/images/icons/edit.png" style="width:20px; margin-left:30px;"> گزینه های سفر
                </v-btn>
              </div>
            </div>

            <v-snackbar color="red" style="z-index:10000 !important;" v-model="snackbar">
              {{ text }}

              <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                  بستن
                </v-btn>
              </template>
            </v-snackbar>

            <v-bottom-sheet style="z-index: 1050" v-model="sheet3">
              <v-sheet class="text-center custom-sheet">
                <div class="text-center">
                  <font-awesome-icon @click="sheet3 = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <div style="" class="mx-5">
                  <div class="d-flex flex-column align-center ">
                    <img src="@/assets/images/img/car2.png" style="width:65px; margin-bottom:0px; ">
                    <div>
                      <h2 v-if="!LoadingFalse">{{ formatPrice(TotalGrandTotal) }} <span
                          style="font-size: .8rem; color: green">تومان</span></h2>
                      <span v-if="LoadingFalse" class="loader"></span>
                    </div>
                  </div>

                  <div style="padding: 10px">
                    <div class="d-flex justify-space-between">
                      <div @click="NextStep3" class="d-flex justify-space-between align-center pointer">
                        <img src="@/assets/images/icons/record-circle-outline.svg"
                          style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> مقصد دوم</h3>
                      </div>
                      <h3 @click="DeleteRemoveMarker" v-if="Lastmarker" class="red--text py-3 pointer">حذف</h3>
                    </div>

                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/phone.svg" style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size">تلفن تماس</h3>
                      </div>
                      <!-- <h3 class="grey--text py-5">ایستگاه سرویس دستی</h3> -->

                      <input type="text" @keypress="isNumber()" maxlength="11" v-model="phone" value=""
                        class="my-2 text-center" style="background-color:#e0e4ec; border-radius:8px; width:150px;">
                    </div>
                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/alarm.svg" style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> توقف در مسیر</h3>
                      </div>
                      <!-- <h3 class="grey--text py-5">ایستگاه سرویس دستی</h3> -->
                      <input type="text" @keypress="isNumber()" maxlength="3" v-model="StopMinutesPrice"
                        @keyup="CalculateKM" value="" class="my-2 text-center"
                        style="background-color:#e0e4ec; border-radius:8px; width:150px;">
                    </div>
                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/swap-horizontal.svg" style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> رفت و برگشت</h3>
                      </div>

                      <v-switch style="margin-top: 10px !important;" v-model="ExchangeBTN" hide-details inset
                        @click="BtnShowSwitch"></v-switch>
                    </div>
                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/briefcase-arrow-up-down.svg"
                          style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> اضافه بار</h3>
                      </div>
                      <v-switch style="margin-top: 10px !important;" v-model="ezafebar" hide-details inset
                        @click="CalculateKM"></v-switch>
                    </div>
                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/sun-snowflake-variant.svg"
                          style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> کولر</h3>
                      </div>
                      <v-switch style="margin-top: 10px !important;" v-model="koler" hide-details inset
                        @click="CalculateKM"></v-switch>
                    </div>
                    <v-btn v-if="!loading" @click="req_car()" style="font-size: 1rem;width: 100%; color:white;
                 background-color: #08d474; padding:20px; border-radius:10px;
                  margin-left:10px;">ثبت درخواست</v-btn>

                    <v-btn v-if="loading" style="font-size: 1.2rem;width: 100%; color:white;
                 background-color: #08d474; padding:20px; border-radius:10px;
                  margin-left:10px;">
                      <span>تایید</span>
                      <v-icon size="30" color="white darken-1">mdi-loading mdi-spin</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet4">
              <v-sheet class="text-center custom-sheet">
                <div class="text-center">
                  <font-awesome-icon @click="sheet4 = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <!-- <v-btn
                  class="mt-6"
                  text
                  color="red"
                  @click="sheet = !sheet"
                >
                  بستن
                </v-btn> -->
                <div style="" class="mx-5">

                  <div class="d-flex flex-column align-center ">
                    <img src="@/assets/images/img/car2.png" style="width:65px; margin-bottom:0px; ">
                    <div>
                      <h2 v-if="!LoadingFalse">{{ formatPrice(TotalGrandTotal) }} <span
                          style="font-size: .8rem; color: green">تومان</span></h2>
                      <span v-if="LoadingFalse" class="loader"></span>

                    </div>
                  </div>


                  <div style="padding: 10px">
                    <div class="d-flex justify-space-between">
                      <div @click="NextStep3" class="d-flex justify-space-between align-center pointer">
                        <img src="@/assets/images/icons/record-circle-outline.svg"
                          style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> مقصد دوم</h3>
                      </div>
                      <h3 @click="DeleteRemoveMarker" v-if="Lastmarker" class="red--text py-3 pointer">حذف</h3>
                    </div>
                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/phone.svg" style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size">تلفن تماس</h3>
                      </div>
                      <!-- <h3 class="grey--text py-5">ایستگاه سرویس دستی</h3> -->
                      <input type="text" @keypress="isNumber()" maxlength="11" v-model="phone" value=""
                        class="my-2 text-center" style="background-color:#e0e4ec; border-radius:8px; width:150px;">
                    </div>
                    <hr />

                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/alarm.svg" style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> توقف در مسیر</h3>
                      </div>
                      <!-- <h3 class="grey--text py-5">ایستگاه سرویس دستی</h3> -->
                      <input type="text" @keypress="isNumber()" maxlength="3" v-model="StopMinutesPrice"
                        @keyup="CalculateKM" value="" class="my-2 text-center"
                        style="background-color:#e0e4ec; border-radius:8px; width:150px;">
                    </div>
                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/swap-horizontal.svg" style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> رفت و برگشت</h3>
                      </div>

                      <v-switch style="margin-top: 10px !important;" v-model="ExchangeBTN" hide-details inset
                        @click="BtnShowSwitch"></v-switch>
                    </div>
                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/briefcase-arrow-up-down.svg"
                          style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> اضافه بار</h3>
                      </div>
                      <v-switch style="margin-top: 10px !important;" v-model="ezafebar" hide-details inset
                        @click="CalculateKM"></v-switch>
                    </div>
                    <hr />
                    <div class="d-flex justify-space-between">
                      <div class="d-flex justify-space-between align-center">
                        <img src="@/assets/images/icons/sun-snowflake-variant.svg"
                          style="width:20px; margin-left:6px; ">
                        <h3 class="py-3 op-size"> کولر</h3>
                      </div>
                      <v-switch style="margin-top: 10px !important;" v-model="koler" hide-details inset
                        @click="CalculateKM"></v-switch>
                    </div>
                    <v-btn v-if="!loading" @click="req_car()" style="font-size: 1rem;width: 100%; color:white;
                 background-color: #08d474; padding:20px; border-radius:10px;
                  margin-left:10px;">ثبت درخواست</v-btn>

                    <v-btn v-if="loading" style="font-size: 1.2rem;width: 100%; color:white;
                 background-color: #08d474; padding:20px; border-radius:10px;
                  margin-left:10px;">
                      <span>تایید</span>
                      <v-icon size="30" color="white darken-1">mdi-loading mdi-spin</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>

            <v-bottom-sheet style="z-index: 1050" v-model="reserve_sheet">
              <v-sheet class="text-center py-2 px-2" height="33rem">
                <div class="text-center">
                  <font-awesome-icon @click="reserve_sheet = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <div style="color: #df1b1b;font-weight: 600" class="mt-3">
                  ساعت و زمان رزرو را انتخاب کنید
                </div>

                <div>

                  <v-time-picker v-model="reserve" class="mt-4"></v-time-picker>
                  {{ reserve }}
                </div>
                <v-btn color="primary" class="mt-2" @click="accept_reserve()">تایید زمان رزرو</v-btn>

              </v-sheet>
            </v-bottom-sheet>



          </div>
          <div v-if="step == 4" class="text-center">
            <div style="width: 90%; margin: auto">
              <div :style="BtnStyle" @click="OpenModel1" class="d-flex  justify-space-between bg-white"
                style="font-size:1rem; width: 100%; margin: auto; margin-bottom: 20px !important; border: 2px solid #eee; height:45px; padding:6px; border-radius:5px;">
                <h4 v-if="markerOne == ''" style="font-weight: 400">کجا هستید ؟</h4>
                <h4 v-if="markerOne != ''"
                  style="font-weight: 400; color: green;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                  {{ markerOne.name }}</h4>
                <img src="/app/img/SearchLogo.png" alt="SearchLogo" style="height: 22px; width: 22px">
              </div>
            </div>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <v-text-field v-model="SearchList" class="mx-5" label="کجا هستید؟"></v-text-field>

                <div class="ListShowToUser">
                  <v-row class="mt-1 " v-if="list.length > 0">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>
                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet = false">
                      <div @click="BtnSendData(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">
                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>

                  <!--              history title-->
                  <v-row class="mt-1 " v-if="list.length == 0">
                    <span class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet = false">
                        <div @click="BtnSendData(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>

            <div style="cursor: pointer">
              <div style="width: 90%; margin: auto">
                <div :style="BtnStyle1" @click="OpenModel2" class="d-flex  justify-space-between bg-white"
                  style="font-size:1rem; width: 100%; margin: auto; margin-bottom: 20px !important; border: 2px solid #eee; height:45px; padding:6px; border-radius:5px;">
                  <h4 v-if="markerTwo == ''" style="font-weight: 400">کجا می روید؟</h4>
                  <h4 v-if="markerTwo != ''"
                    style="font-weight: 400; color: green;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    {{ markerTwo.name }}</h4>
                  <img src="/app/img/SearchLogo.png" alt="SearchLogo" style="height: 22px; width: 22px">
                </div>
              </div>
            </div>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet1">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet1 = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <v-text-field v-model="SearchList" class="mx-5" label="کجا می روید؟"></v-text-field>

                <div class="ListShowToUser">
                  <v-row class="mt-1 " v-if="list.length > 0">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>
                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet1 = false">
                      <div @click="BtnSendData2(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">
                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                  <!--              history title-->
                  <v-row class="mt-1 " v-if="list.length == 0">
                    <span class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet1 = false">
                        <div @click="BtnSendData2(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>

            <div style="cursor: pointer">
              <div style="width: 90%; margin: auto">
                <div :style="BtnStyle2" @click="OpenModel3" class="d-flex  justify-space-between bg-white"
                  style="font-size:1rem; width: 100%; margin: auto; margin-bottom: 0px !important; border: 2px solid #eee; height:45px; padding:6px; border-radius:5px;">
                  <h4 v-if="markerThree == ''" style="font-weight: 400">مقصد دومت کجاست ؟</h4>
                  <h4 v-if="markerThree != ''"
                    style="font-weight: 400; color: green;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    {{ markerThree.name }}</h4>
                  <img src="/app/img/SearchLogo.png" alt="SearchLogo" style="height: 22px; width: 22px">
                </div>
              </div>

              <!--          <div class="divClassDivCloseButton">-->
              <!--            <v-btn @click="SuccessPage3"-->
              <!--              style="font-size:1rem; width: 100%; margin: auto; border-radius: 5px; color: white; background-color: #00bc6e; padding:10px; height:45px; ">تایید-->
              <!--              مقصد دوم</v-btn>-->
              <!--            <div class="DivCloseButton" @click="ClosePage4">-->
              <!--              برگشت-->
              <!--            </div>-->
              <!--          </div>-->

            </div>
            <br>
            <v-bottom-sheet style="z-index: 1050" v-model="sheet2">
              <v-sheet class="text-center" height="800px">
                <div class="text-center">
                  <font-awesome-icon @click="sheet2 = false" size="lg" :icon="['fas', 'chevron-down']" />
                </div>
                <v-text-field v-model="SearchList" class="mx-5" label="مقصد دومتون کجاست؟"></v-text-field>

                <div class="ListShowToUser">
                  <v-row class="mt-1 " v-if="list.length > 0">
                    <span class="text-h6">نتایج جستجو</span>
                  </v-row>
                  <div v-if="list.length > 0">
                    <div v-for="(lists, index) in list" :key="index" @click="sheet2 = false">
                      <div @click="BtnSendData3(lists)" class="ChildListShowToUser">
                        <v-row align="center">
                          <v-col cols="1" class="text-center">
                            <MapIconPlaceInSearch :icon_type="lists.type" />
                          </v-col>
                          <v-col cols="11">
                            <div>{{ lists.title }} ({{ lists.region }})</div>
                            <div style="font-size: 13px">{{ lists.address }}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                  <!--              history title-->
                  <v-row class="mt-1 " v-if="list.length == 0">
                    <span class="text-h6">

                      مکان های پیشنهادی</span>
                  </v-row>
                  <!--              history list-->
                  <div v-if="list.length == 0">
                    <div v-if="history_map_list.length > 0">
                      <div v-for="(lists, index) in history_map_list" :key="index" @click="sheet2 = false">
                        <div @click="BtnSendData3(lists, 'history')" class="ChildListShowToUser">
                          <v-row align="center">
                            <v-col cols="1" class="text-center">

                              <MapIconPlaceInSearch :icon_type="'history'" />
                            </v-col>
                            <v-col cols="11">
                              <div>{{ lists.address }}</div>
                              <!--                        <div style="font-size: 13px">{{ lists.address }}</div>-->
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                    <div v-else class="mt-4">

                      سابقه ای یافت نشد
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-bottom-sheet>

          </div>
        </div>
      </div>
    </div>
    <SocketListner ref="MySocketListner" />
    <AndroidGeolocation  />
  </div>
</template>



<script>
import { mapGetters } from 'vuex';
import axios from 'axios'
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import SocketListner from "../components/SocketListner.vue";
import MapIconPlaceInSearch from "/src/components/MapIconPlaceInSearch";
import AndroidGeolocation from "../components/AndroidGeolocation.vue";
export default {
  name: 'manualService',
  components: {
    MapIconPlaceInSearch,
    SocketListner,
    AndroidGeolocation,
  },
  data() {
    return {
      around_car: [],
      around_loc: [],
      ExchangeBTN: false,
      ezafebar: false,
      koler: false,
      sheet: false,
      sheet1: false,
      sheet2: false,
      sheet3: false,
      sheet4: false,
      reserve_sheet: false,
      choose_car_sheet: false,
      code: '',
      last_sheet: 0,
      LoadingFalse: false,
      e6: 1,
      step: 1,
      step1: 10,
      step2: '',
      dropArea: null,
      file_list: [],
      loading: false,
      items_subcategory: [],
      items_state: [],
      items_city: [],
      param: {
        CarType: 'sedan',
        content: '',
        latitude: '',
        longitude: '',
        category: null,
        sub_category: null,
        main_category: null,
        meter_price: null,
        mortgage_price: null,
        rent_price: null,
        total_price: null,
        building_area: null,
        land_area: null,
        floor: null,
        state: null,
        city: null,
        address: null,
        comment_status: null,
        owner_name: '',
        search_address: null,
        contact: '',
        details: null,
      },
      lat: '',
      BtnStyle: '',
      BtnStyle1: '',
      BtnStyle2: '',
      lng: '',
      map: null,
      marker_add: 0,
      marker_add1: 0,
      marker_add2: 0,
      marker1: null,
      marker2: null,
      marker3: null,
      pointmarker: null,
      ReverseLocationToAddress_switch: true,
      list: [],
      Lastmarker: false,
      reserve: '',
      is_reserved: 'no',
      markerOne: '',
      markerTwo: '',
      markerThree: '',
      StopMinutesPrice: 0,
      phone: '',
      SearchList: '',
      userBox: '',
      setState: '',
      setState1: [],
      currLocation: '',
      timer: null,
      time: '',

      TotalGrandTotal: 0,
      realprice: 0,
      mapFare: 0,
      stopPrice: 0,
      discount_price: 0,
      discount_id: 0,
      has_discount: 0,
      snackbar: false,
      snackbar2: false,
      snackbar3: false,
      bon_loading: false,
      text: ``,
      destination_lat: '',
      destination_lng: '',
      second_destination_lat: '',
      second_destination_lng: '',
      directionDistance: 0,
      directionDuration: 0,
      noTrafficDuration: 0,
      history_map_list: [],
      pub_lat: 27.19592444235048,
      pub_lan: 56.289279369887296,
      fareRange: [],
      setting_info: []
    }
  },

  watch: {
    SearchList() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.SearchLocation, 1000);
    }
  },
  created() {
    this.get_loc('', '', 'f')

  },
  mounted() {

    let self = this;
    self.getInfo();
    self.RangeList();
    self.componentWillMount();
    self.mapCreate(self.pub_lat, self.pub_lan);

    self.dropArea = document.getElementById('drop-area');

    this.phone = this.userBox.mobile

  },
  computed: {
    ...mapGetters(['baseUrl', "auth"]),
  },
  methods: {
    get_loc(latitude, longitude, from) {
      let self = this;
      var lat = self.pub_lat;
      var long = self.pub_lan;

      if (from == 's') {
        lat = latitude;
        long = longitude;
      }
      //
      if (from == 'f') {

        const success = (position) => {
          console.log('lll', position)
          lat = position.coords.latitude;
          long = position.coords.longitude;

          self.pub_lat = lat;
          self.pub_lan = long;

          // Do something with the position
        };

        const error = () => {

        };

        // This will open permission popup
        navigator.geolocation.getCurrentPosition(success, error);

        setTimeout(function () {
          self.pointmarker.setLatLng([lat, long]);
          self.map.setView([lat, long]);
        }, 1000)
      }



    },
    getInfo() {
      this.userBox = JSON.parse(localStorage.getItem('auth'));
      console.log(this.userBox)
      fetch(this.baseUrl + '/setting?token=' + this.userBox.token + "&public_token=" + this.userBox.public_token + "&uid=" + this.userBox.uid)
        .then(response => response.json())
        .then(json => {
          if (json.data.driver_status == true) {
            this.setting_info = json.data;
          }
        })
        .catch(error => console.log(error))
    },

    req_car() {
      let self = this;
      self.loading = true;
      let newParam = {};
      newParam.token = this.userBox.token;
      newParam.car_type = this.userBox.car_type;
      newParam.mobile = this.userBox.mobile;
      newParam.uid = this.userBox.uid;
      newParam.public_token = this.userBox.public_token;
      newParam.nickname = this.userBox.nickname;
      // newParam.station_id = 1;
      // newParam.service_id = 1;
      newParam.directionDistance = this.directionDistance;
      newParam.directionDuration = this.directionDuration;
      newParam.noTrafficDuration = this.noTrafficDuration;
      newParam.hasAC = this.koler;
      newParam.totalFare = this.TotalGrandTotal;
      newParam.mapFare = this.mapFare;
      newParam.cargoPrice = this.setState1.cargo_price;
      newParam.stopPrice = this.stopPrice;
      newParam.acPrice = this.setState1.ac_price;
      newParam.hasCargo = this.ezafebar;
      newParam.hasReturn = this.ExchangeBTN;
      newParam.latitude = this.param.latitude;
      newParam.longitude = this.param.longitude;
      newParam.origin_title = this.markerOne.name;
      newParam.destination_lat = this.destination_lat;
      newParam.destination_lng = this.destination_lng;
      newParam.destination_title = this.markerTwo.name;
      newParam.second_destination_lat = this.second_destination_lat;
      newParam.second_destination_lng = this.second_destination_lng;
      newParam.second_destination_title = this.markerThree.name;


      this.helperPost('save-in-person-passenger', newParam).then(function (r) {
        console.log('shodshod', r);

        if (r.data.result == '1') {
          self.$router.push({
            name: 'home',
          })
          // self.$router.push({
          //   name: '/',
          //   params: {
          //     obj: { ...r.data.data },
          //     setting_info: {...this.setting_info}
          //   }
          // })
        }
        self.loading = false;
      }).catch(function () {
        self.loading = false;
      })
    },



    BtnShowSwitch() {
      this.CalculateKM()
    },
    BtnShowIt3() {
      if (this.markerOne != '') {
        if (this.markerTwo != '') {
          this.sheet3 = !this.sheet3;
          this.CalculateKM();
          this.snackbar = false;
        } else {
          this.snackbar = true;
          this.text = "مقصد دوم انتخاب نشده";
        }
      } else {
        this.snackbar = true
        this.text = "مقصد دوم انتخاب نشده"

      }
    },
    BtnShowIt4() {
      if (this.markerOne != '') {
        if (this.markerTwo != '') {
          this.CalculateKM();
          this.snackbar = false
        } else {
          this.snackbar = true
          this.text = "مقصد دوم انتخاب نشده"
        }
      } else {
        this.snackbar = true
        this.text = "مقصد دوم انتخاب نشده"
      }
    },
    // ================== open modal ======================
    OpenModel1() {
      // if (this.markerOne != '') {
      this.step1 = 1
      this.sheet = !this.sheet
      // }
    },
    OpenModel2() {
      this.step1 = 2
      this.sheet1 = !this.sheet1
    },
    OpenModel3() {
      this.step1 = 3
      this.sheet2 = !this.sheet2
    },
    // ================== create map ======================
    mapCreate(lat, lng) {

      let self = this;
      // ================== defult lat lng ======================
      let latitud = lat;
      let langtitud = lng;

      // ================== map options ======================
      let mapOptions = {
        center: [latitud, langtitud],
        zoom: 16,
        fullscreenControl: true,
      };


      self.map = new L.map('map', mapOptions); // Creating a map object
      let layer = new L.TileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png'); // Creating a Layer object
      self.map.addLayer(layer); // Adding layer to the map
      this.marker_add = 0;
      self.map.on('moveend', function () {
        const center = self.map.getCenter();
        // const zoom = self.map.getZoom();
        if (self.ReverseLocationToAddress_switch) {
          self.ReverseLocationToAddress(center.lat, center.lng);

        }

        self.get_loc(center.lat, center.lng, 's');
      });

      //ایحاد نقطه متحرک
      self.pointmarker = new L.Marker([latitud, langtitud], {
        draggable: false,
        icon: new L.DivIcon({
          iconAnchor: [-7, 55],
          elevation: 0,
          title: "مکان",
          className: 'my-div-icon',
          html: '<div><img style="margin-top:15px;margin-right:5px;width: 25px" class="my-div-image" src="/app/img/pin.png"/>' +
            '<span class="my-div-span busy"></span></div>',
          //html: img,
        })
      });
      self.pointmarker.addTo(self.map);

      self.pointmarker.on('click', (e) => {
        let $lat = e.latlng.lat;
        let $lng = e.latlng.lng;

        self.mapAction($lat, $lng);
      });

      self.map.on('move', function () {
        const latLng = self.map.getCenter();

        self.pointmarker.setLatLng(latLng);
      });

      //set location when map and page is loaded
      const center = self.map.getCenter();
      // const zoom = self.map.getZoom();
      if (self.ReverseLocationToAddress_switch) {
        self.ReverseLocationToAddress(center.lat, center.lng);

      }
    },
    // ================== get marker name ======================
    async ReverseLocationToAddress($lat, $lng) {
      let self = this;
      axios.get('https://api.neshan.org/v4/reverse?lat=' + $lat + '&lng=' + $lng, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Api-Key': 'service.aa478f35b58c41069acddbd60d5aec08',
        },
      }).then(response => {
        this.setState = response.data.formatted_address;

        if (self.step1 == 10) {
          self.markerOne = { name: self.setState }
        }
        if (self.step1 == 2) {
          self.markerTwo = { name: self.setState }
        }

        if (self.step1 == 3) {
          self.markerThree = { name: self.setState }
        }
      })
    },
    // ================== search to get city ======================
    SearchLocation() {
      let self = this;
      var lat = self.pub_lat
      var lng = self.pub_lan;
      axios.get('https://api.neshan.org/v1/search?term=' + this.SearchList + '&lat=' + lat + '&lng=' + lng, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Api-Key': 'service.aa478f35b58c41069acddbd60d5aec08',
        },
      })
        .then(response => {
          this.list = response.data.items;
        })
    },
    // ================== send data to neshan for get data ======================
    async componentWillMount() {
      var token = this.userBox.token;
      var PublicTokens = this.userBox.public_token;
      var uidShow = this.userBox.uid;
      axios.get(this.baseUrl + '/customer/setting?token=' + token + '&public_token=' + PublicTokens + '&uid=' + uidShow)
        .then(response => {
          let data = response.data;
          // console.log('sss',response.data.data)
          this.pub_lat = response.data.data.city_center_lat;
          this.pub_lan = response.data.data.city_center_lng;
          this.setState1 = {
            ac_price: data.data.ac_price,
            cargo_price: parseFloat(data.data.cargo_price),
            stop_unit: parseFloat(data.data.stop_price),
            TrafficTime: parseFloat(data.data.trafficFare),
            KM_price: parseFloat(data.data.kilometerFare),
            ladyPercent: parseFloat(data.data.lady_percent),
            luxPercent: parseFloat(data.data.lux_percent),
            bikePercent: parseFloat(data.data.bike_percent),
            minServiceFare: parseFloat(data.data.minServiceFare),
            max_city_area: parseFloat(data.data.max_city_area),
            plus_destination_fare: parseFloat(data.data.plus_destination_fare),
            visible: false,
          }


        })

      // BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    },
    // ================== add marker ======================
    mapAction: function ($lat, $lng) {

      let self = this;
      if (self.step1 != 0) {
        self.map.setView([$lat, $lng]);
      }
      // ================== send data to get name ======================
      // self.ReverseLocationToAddress($lat, $lng);

      // ================== send data to neshan for get data ======================


      // ================== defult marker ======================
      setTimeout(() => {

        if (this.step1 == 10) {
          if (this.marker_add == 0) {
            self.marker1 = new L.Marker([$lat, $lng], {
              draggable: false,
              icon: new L.DivIcon({
                iconAnchor: [-7, 55],
                elevation: 0,
                title: "مکان",
                className: 'my-div-icon',
                html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker1.png" width="60px"/>' +
                  '<span class="my-div-span busy"></span></div>',
                //html: img,
              })
            });

            self.marker1.addTo(self.map);
            self.marker1.on('dragend', function () {
              let coord = self.marker1.getLatLng();
              let lat = coord.lat;
              let lng = coord.lng;
              self.param.latitude = lat;
              self.param.longitude = lng;
            });
            this.marker_add = 1;
            document.getElementById('ClosePage4').classList.remove('d-none')

          }
          self.param.latitude = $lat;
          self.param.longitude = $lng;
          var newLatLng = new L.LatLng($lat, $lng);
          self.marker1.setLatLng(newLatLng);
          this.markerOne = { name: self.setState, lat: $lat, lng: $lng }
          this.step1 = 1
          this.NextStep();
        }


      }, 300);

      // ================== marker 1 (defult marker should be like me) ======================
      if (this.step1 == 1) {
        if (this.marker_add == 0) {
          self.marker1 = new L.Marker([$lat, $lng], {
            draggable: false,
            icon: new L.DivIcon({
              iconAnchor: [-7, 55],
              elevation: 0,
              title: "مکان",
              className: 'my-div-icon',
              html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker1.png" width="60px"/>' +
                '<span class="my-div-span busy"></span></div>',
              //html: img,
            })
          });

          self.marker1.addTo(self.map);
          self.marker1.on('dragend', function () {
            let coord = self.marker1.getLatLng();
            let lat = coord.lat;
            let lng = coord.lng;
            self.param.latitude = lat;
            self.param.longitude = lng;
          });
          this.marker_add = 1;

        }
        self.param.latitude = $lat;
        self.param.longitude = $lng;
        var newLatLng = new L.LatLng($lat, $lng);
        self.marker1.setLatLng(newLatLng);
        setTimeout(() => {
          this.markerOne = { name: self.setState, lat: $lat, lng: $lng }
        }, 500);

      }

      // ================== marker 2 ======================
      if (this.step1 == 2) {
        if (this.marker_add1 == 0) {
          self.marker2 = new L.Marker([$lat, $lng], {
            draggable: false,
            icon: new L.DivIcon({
              iconAnchor: [-7, 55],
              elevation: 0,
              title: "مکان",
              className: 'my-div-icon',
              html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker2.png" width="60px"/>' +
                '<span class="my-div-span busy"></span></div>',
              //html: img,
            })
          });
          self.marker2.addTo(self.map);
          self.destination_lat = $lat;
          self.destination_lng = $lng;
          self.marker2.on('dragend', function () {

            let coord = self.marker2.getLatLng();
            let lat = coord.lat;
            let lng = coord.lng;
            self.destination_lat = lat;
            self.destination_lng = lng;

          });
          this.marker_add1 = 1;
        }
        // self.param.latitude = $lat;
        // self.param.longitude = $lng;
        var newLatLng1 = new L.LatLng($lat, $lng);
        self.marker2.setLatLng(newLatLng1);
        // setTimeout(() => {
        this.markerTwo = { name: self.setState, lat: $lat, lng: $lng }
        // }, 500);

        this.NextStep2();
      }

      // ================== marker 3 ======================
      if (this.step1 == 3) {
        if (this.marker_add2 == 0) {

          self.marker3 = new L.Marker([$lat, $lng], {
            draggable: false,
            icon: new L.DivIcon({
              iconAnchor: [-7, 55],
              elevation: 0,
              title: "مکان",
              className: 'my-div-icon',
              html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker3.png" width="60px"/>' +
                '<span class="my-div-span busy"></span></div>',
              //html: img,
            })
          });
          self.marker3.addTo(self.map);
          self.second_destination_lat = $lat;
          self.second_destination_lng = $lng;
          self.marker3.on('dragend', function () {
            let coord = self.marker3.getLatLng();
            let lat = coord.lat;
            let lng = coord.lng;
            self.second_destination_lat = lat;
            self.second_destination_lng = lng;
          });
          this.marker_add2 = 1;
        }
        // self.param.latitude = $lat;
        // self.param.longitude = $lng;
        var newLatLng3 = new L.LatLng($lat, $lng);
        self.marker3.setLatLng(newLatLng3);

        this.markerThree = { name: self.setState, lat: $lat, lng: $lng }
        this.SuccessPage3();
        this.Lastmarker = true

      }
    },
    // ================== click on search pop pop 1 ======================
    BtnSendData(lists, from) {
      let self = this;
      this.markerOne = lists
      let latitud;
      let langtitud;
      self.pointmarker.remove();
      if (from == 'history') {
        latitud = lists.lat;
        langtitud = lists.lng;
        // self.map.setView(lists.lat, lists.lng);
      }
      else {
        latitud = lists.location.y;
        langtitud = lists.location.x;
        // self.map.setView(lists.location.y, lists.location.x);

      }


      self.pointmarker = new L.Marker([latitud, langtitud], {
        draggable: false,
        icon: new L.DivIcon({
          iconAnchor: [-7, 55],
          elevation: 0,
          title: "مکان",
          className: 'my-div-icon',
          html: '<div><img style="margin-top:15px;margin-right:5px;width: 25px" class="my-div-image" src="/app/img/pin.png"/>' +
            '<span class="my-div-span busy"></span></div>',
          //html: img,
        })
      });
      self.pointmarker.addTo(self.map);
      self.pointmarker.setLatLng([latitud, langtitud]);
      self.map.setView([latitud, langtitud], 20);
      self.ReverseLocationToAddress_switch = true
      self.pointmarker.on('click', (e) => {
        let $lat = e.latlng.lat;
        let $lng = e.latlng.lng;

        self.mapAction($lat, $lng);
      });
      self.step1 = 10

    },
    // ================== click on search pop pop 2 ======================
    BtnSendData2(lists, from) {
      let self = this;
      this.markerTwo = lists
      let latitud;
      let langtitud;
      self.pointmarker.remove();
      if (from == 'history') {
        latitud = lists.lat;
        langtitud = lists.lng;
        // self.map.setView(lists.lat, lists.lng);
      }
      else {
        latitud = lists.location.y;
        langtitud = lists.location.x;
        // self.map.setView(lists.location.y, lists.location.x);

      }


      self.pointmarker = new L.Marker([latitud, langtitud], {
        draggable: false,
        icon: new L.DivIcon({
          iconAnchor: [-7, 55],
          elevation: 0,
          title: "مکان",
          className: 'my-div-icon',
          html: '<div><img style="margin-top:15px;margin-right:5px;width: 25px" class="my-div-image" src="/app/img/pin.png"/>' +
            '<span class="my-div-span busy"></span></div>',
          //html: img,
        })
      });
      self.pointmarker.addTo(self.map);
      self.pointmarker.setLatLng([latitud, langtitud]);
      self.map.setView([latitud, langtitud], 20);
      self.ReverseLocationToAddress_switch = true
      self.pointmarker.on('click', (e) => {
        let $lat = e.latlng.lat;
        let $lng = e.latlng.lng;

        self.mapAction($lat, $lng);
      });
      this.destination_lat = lists.location.y;
      this.destination_lng = lists.location.x;
      this.step1 = 2
    },
    // ================== click on search pop pop 2 ======================
    BtnSendData3(lists, from) {
      let self = this;

      let latitud;
      let langtitud;
      self.pointmarker.remove();
      this.markerThree = lists
      if (from == 'history') {
        latitud = lists.lat;
        langtitud = lists.lng;
        this.second_destination_lat = lists.lat;
        this.second_destination_lng = lists.lng;
      }
      else {
        latitud = lists.location.y;
        langtitud = lists.location.x;
        this.second_destination_lat = lists.location.y;
        this.second_destination_lng = lists.location.x;
      }

      self.pointmarker = new L.Marker([latitud, langtitud], {
        draggable: false,
        icon: new L.DivIcon({
          iconAnchor: [-7, 55],
          elevation: 0,
          title: "مکان",
          className: 'my-div-icon',
          html: '<div><img style="margin-top:15px;margin-right:5px;width: 25px" class="my-div-image" src="/app/img/pin.png"/>' +
            '<span class="my-div-span busy"></span></div>',
          //html: img,
        })
      });
      self.pointmarker.addTo(self.map);
      self.pointmarker.setLatLng([latitud, langtitud]);
      self.map.setView([latitud, langtitud], 20);
      self.ReverseLocationToAddress_switch = true
      self.pointmarker.on('click', (e) => {
        let $lat = e.latlng.lat;
        let $lng = e.latlng.lng;

        self.mapAction($lat, $lng);
      });
      this.step1 = 3
    },
    // ================== go to page 2 ======================
    NextStep() {
      let self = this;
      if (self.markerOne != '') {
        self.step = 2
        self.step1 = 2
        self.BtnStyle = ''
        self.list = []
        self.SearchList = ''
      } else {
        self.BtnStyle = 'border: 1px solid red'
      }


    },
    // ================== go to page 3 ======================
    NextStep2() {
      let self = this;
      if (self.markerTwo != '') {
        self.CalculateKM()
        self.step = 3
        self.BtnStyle1 = ''
        self.step1 = 0
        self.list = []
        self.SearchList = ''

        self.pointmarker.remove();
        self.ReverseLocationToAddress_switch = false
      } else {
        self.BtnStyle1 = 'border: 1px solid red'
      }
    },
    // ================== go to page 4 ======================
    NextStep3() {
      let self = this;
      if (this.markerThree == '') {
        this.step = 4
        this.step1 = 3
        // ایحاد نقطه متحرک
        self.pointmarker = new L.Marker([self.markerTwo.lat, self.markerTwo.lng], {
          draggable: false,
          icon: new L.DivIcon({
            iconAnchor: [-7, 55],
            elevation: 0,
            title: "مکان",
            className: 'my-div-icon',
            html: '<div><img style="margin-top:15px;margin-right:5px;width: 25px" class="my-div-image" src="/app/img/pin.png"/>' +
              '<span class="my-div-span busy"></span></div>',
            //html: img,
          })
        });
        self.pointmarker.addTo(self.map);
        self.pointmarker.setLatLng([self.markerTwo.lat, self.markerTwo.lng]);
        self.map.setView([self.markerTwo.lat, self.markerTwo.lng]);
        self.ReverseLocationToAddress_switch = true
        self.pointmarker.on('click', (e) => {
          let $lat = e.latlng.lat;
          let $lng = e.latlng.lng;

          self.mapAction($lat, $lng);
        });
        if (this.sheet3 == true) {
          this.sheet3 = !this.sheet3
          this.last_sheet = 3;
        }
        if (this.sheet4 == true) {
          this.sheet4 = !this.sheet4
          this.last_sheet = 4;
        }
        this.list = []
        this.SearchList = ''
      }

    },
    NextStep4() {
      if (this.sheet3 == true) {
        this.sheet3 = !this.sheet3
        this.reserve_sheet = !this.reserve_sheet
        this.last_sheet = 3;

      }
      if (this.sheet4 == true) {
        this.sheet4 = !this.sheet4
        this.reserve_sheet = !this.reserve_sheet
        this.last_sheet = 4;

      }
    },
    accept_reserve() {
      if (this.reserve) {
        if (this.reserve.length == 5) {
          this.reserve = this.reserve + ':00'
        }
        this.is_reserved = 'yes';
      } else {
        this.reserve = '';
        this.is_reserved = 'no';
      }
      if (this.last_sheet == 3) {
        this.sheet3 = !this.sheet3
        this.reserve_sheet = !this.reserve_sheet

      }
      if (this.last_sheet == 4) {
        this.sheet4 = !this.sheet4
        this.reserve_sheet = !this.reserve_sheet
      }
      this.last_sheet = 0;
    },
    // ================== back to page 3 ======================
    SuccessPage3() {

      let self = this;
      if (this.markerThree != '') {
        this.CalculateKM()
        this.step = 3
        this.step1 = 0
        this.BtnStyle2 = ''
        this.list = []
        self.ReverseLocationToAddress_switch = false
        self.pointmarker.remove();
      } else {
        this.BtnStyle2 = 'border: 1px solid red'
      }
    },
    // ================== close page 4 ======================
    ClosePage4() {
      let self = this;
      let or = false;
      let d1 = false;
      let d2 = false;

      if (self.step == 1) {

        let self = this;
        self.$router.push({
          name: 'manualservice'
        })

      }
      if (self.step == 2) {
        or = true;
      }
      if (self.step == 3) {
        d1 = true;
        or = true;
      }

      if (self.marker3 != null) {
        d2 = true;
      }


      self.step = 1
      self.step1 = 10
      self.BtnStyle2 = ''
      self.list = []
      self.SearchList = ''
      self.marker_add = 0;
      self.marker_add1 = 0;
      self.marker_add2 = 0;
      self.markerOne = '';
      self.markerTwo = '';
      self.markerThree = ''
      if (or) {
        self.marker1.remove();
        self.pointmarker.remove();
        document.getElementById('ClosePage4').classList.add('d-none')
      }

      if (d1)
        self.marker2.remove();
      if (d2)
        self.marker3.remove();

      if (or)
        self.marker1 = null;
      if (d1)
        self.marker2 = null;
      if (d2)
        self.marker3 = null;

      if (or) {
        //ایحاد نقطه متحرک
        self.pointmarker = new L.Marker([self.pub_lat, self.pub_lan], {
          draggable: false,
          icon: new L.DivIcon({
            iconAnchor: [-7, 55],
            elevation: 0,
            title: "مکان",
            className: 'my-div-icon',
            html: '<div><img style="margin-top:15px;margin-right:5px;width: 25px" class="my-div-image" src="/app/img/pin.png"/>' +
              '<span class="my-div-span busy"></span></div>',
            //html: img,
          })
        });
        self.pointmarker.addTo(self.map);
        this.get_loc('', '', 'f')
        self.pointmarker.on('click', (e) => {
          let $lat = e.latlng.lat;
          let $lng = e.latlng.lng;

          self.mapAction($lat, $lng);
        });
        this.ReverseLocationToAddress_switch = true
        this.Lastmarker = false
        this.CalculateKM()
      }
    },
    // ================== remove marker3 in map ======================
    DeleteRemoveMarker() {
      this.map.removeLayer(this.marker3);
      this.Lastmarker = false
      this.markerThree = ''
      this.marker3 = null
      this.step = 3
      this.step1 = 2
      this.marker_add2 = 0
      this.CalculateKM()
    },
    DeleteRemoveReserve() {
      this.reserve = '';
      this.is_reserved = 'no';
    },
    // ================== import shahram method ======================
    async RangeList() {
      await fetch(this.baseUrl + '/customer/get-fare-range-list?public_token=' + this.userBox.public_token + '&uid=' + this.userBox.uid)
        .then(response => response.json())
        .then(json => {
          let data = json.data;
          if (json.result === '1') {

            this.fareRange = data;
          }
        })
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    CalculateKM() {
      let self = this
      this.LoadingFalse = true
      var Origin = { latitude: self.markerOne.lat, longitude: self.markerOne.lng };
      var Destination = { latitude: self.markerTwo.lat, longitude: self.markerTwo.lng };
      var Destination2 = { latitude: self.markerThree.lat, longitude: self.markerThree.lng };
      var ExchangeBTN = this.ExchangeBTN;
      this.CalNeshanWithTraficAndWithOutTraffic(Origin, Destination, Destination2, ExchangeBTN);
    },
    async CalNeshanWithTraficAndWithOutTraffic(origin, destination, Destination2, ExchangeBTN) {

      var resultNoTraffic = await this.CalcNeshanNoTraffic(origin, destination, Destination2, ExchangeBTN);
      console.log('resultNoTraffic', resultNoTraffic)
      var resultWithTraffic = await this.CalcNeshanWithTraffic(origin, destination, Destination2, ExchangeBTN);
      console.log('resultWithTraffic', resultWithTraffic)
      //Calculate
      await this.delay(2000);
      //setTimeout(function () {
      var DurationWthTraffic = parseFloat(resultWithTraffic.Duration);
      var DurationNoTraffic = parseFloat(resultNoTraffic.Duration);
      // var DistanceNoTraffic = parseFloat(resultNoTraffic.Distance);
      var DistancewithTraffic = parseInt(resultWithTraffic.Distance);

      // var KM_price = parseFloat(this.setState1.KM_price);
      var maxCityArea = parseFloat(this.setState1.max_city_area);
      var TrafficTime = parseFloat(this.setState1.TrafficTime);
      var StopMinute = parseFloat(this.StopMinutesPrice);
      var StopUnit = parseFloat(this.setState1.stop_unit);
      var CargoPrice = parseFloat(this.setState1.cargo_price);
      var AcPrice = parseFloat(this.setState1.ac_price);
      var OverLoadBTN = this.setState1.OverLoadBTN;
      var ACBTN = this.setState1.ACBTN;
      var Cargo = 0;


      if (OverLoadBTN === true) {
        Cargo = CargoPrice;
        // console.log('Cargo')
      }
      var AC = 0;
      if (ACBTN === true) {
        AC = AcPrice;
      }

      var StopPrice = 0;
      if (StopMinute > 0) {
        StopPrice = StopMinute * StopUnit;

      }
      this.stopPrice = StopPrice;
      // console.log('StopPrice',StopPrice)
      //-----------------------------------------------------------------------
      // var CalKM = DistanceNoTraffic * KM_price;
      var MoreDuration = parseFloat(DurationWthTraffic - DurationNoTraffic);
      var CalDuration = parseFloat(MoreDuration * TrafficTime);
      // // console.log('CalKM',CalKM)
      // console.log('MoreDuration',MoreDuration)
      // console.log('CalDuration',CalDuration)
      var minServiceFare = this.setState1.minServiceFare;
      var night_extra_percent = parseFloat(this.setState1.night_extra_percent);
      var day_extra_percent = parseFloat(this.setState1.day_extra_percent);

      var total = 0;
      var outCityFare = 0;

      console.log(DistancewithTraffic, maxCityArea);
      if (DistancewithTraffic > maxCityArea) {
        var outCityDistance = DistancewithTraffic - maxCityArea;//0.2
        if (outCityDistance < 1) {
          outCityDistance = 1;
        }
        this.fareRange.forEach(function (v) {
          let range_from = v.from;
          let range_to = v.to;
          let range_price = v.price;
          if (range_from <= outCityDistance && outCityDistance <= range_to) {
            outCityFare = parseFloat(outCityDistance * range_price);
            total = parseFloat(minServiceFare + outCityFare);
          }
        });

      } else {
        total = minServiceFare;
      }


      var mapFare = parseFloat(total + CalDuration);
      this.mapFare = mapFare;
      if (mapFare < minServiceFare) mapFare = minServiceFare;
      // console.log('mapFare',mapFare)
      var GrandTotal = parseFloat(mapFare + StopPrice + Cargo);
      this.TotalGrandTotal = parseFloat(GrandTotal.toFixed(2)) + (GrandTotal * (AC / 100))

      //check incress fare
      if (day_extra_percent > 0) {
        GrandTotal += (GrandTotal * (day_extra_percent / 100));
      }

      if (night_extra_percent > 0) {
        GrandTotal += (GrandTotal * (night_extra_percent / 100));
      }

      if (AC > 0) {
        GrandTotal += GrandTotal * (AC / 100);
      }




      // //--------------------------------------------------------------------
      //car type incress amount
      var ladyPercent = this.setState1.ladyPercent;
      var bikePercent = this.setState1.bikePercent;
      var luxPercent = this.setState1.luxPercent;
      var CarType = this.param.CarType;

      var GrandTotalWithPercent = 0;
      switch (CarType) {
        case 'sedan':
          GrandTotalWithPercent = GrandTotal;
          break;
        case 'bike':
          GrandTotalWithPercent = (GrandTotal * (bikePercent / 100)) + GrandTotal
          break;
        case 'lady':
          GrandTotalWithPercent = (GrandTotal * (ladyPercent / 100)) + GrandTotal
          break;
        case 'luxury':
          GrandTotalWithPercent = (GrandTotal * (luxPercent / 100)) + GrandTotal
          break;
        default:
          GrandTotalWithPercent = GrandTotal
        // code block
      }
      this.TotalGrandTotal = Math.floor(GrandTotalWithPercent / 500) * 500
      if (this.koler == true) {
        this.TotalGrandTotal += (this.setState1.ac_price / 100) * this.TotalGrandTotal;
      }

      if (this.ExchangeBTN == true) {
        this.TotalGrandTotal += (50 / 100) * this.TotalGrandTotal;
      }

      if (this.ezafebar == true) {
        this.TotalGrandTotal += parseInt(this.setState1.cargo_price)
      }

      if (this.markerThree.lat) {
        this.TotalGrandTotal += this.setState1.plus_destination_fare;
      }
      this.LoadingFalse = false;
    //  this.sheet4 = !this.sheet4;

      //}, 2000);

      // await this.setStateAsync({ stop_minute: StopMinute.toString(), Duration: DurationWthTraffic, DistanceNoTraffic: DistanceNoTraffic, Distance: DistanceNoTraffic, AcPrice: AC, stop_price: StopPrice, CargoPrice: Cargo, mapFare: mapFare, GrandTotal: GrandTotalWithPercent, PriceLoading: false, noTrafficDuration: DurationNoTraffic });
    },
    async CalcNeshanNoTraffic(origin, destination, destination2) {
      // check webservice neshan without traffic
      var parameter = "?type=car&origin=" + origin.latitude + ',' + origin.longitude;
      if (this.markerThree != '') {
        parameter += "&waypoints=" + destination.latitude + "," + destination.longitude + '&destination=' + destination2.latitude + ',' + destination2.longitude;
      } else {
        parameter += '&destination=' + destination.latitude + ',' + destination.longitude;
      }

      let responseNoTraffic = await fetch('https://api.neshan.org/v4/direction/no-traffic' + parameter, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Api-Key': 'service.aa478f35b58c41069acddbd60d5aec08',
        },
      });

      let json = await responseNoTraffic.json();
      // console.log('responseNoTraffic',json)
      this.noTrafficDuration = Math.round((json.routes[0].legs[0].duration.value) / 60);
      var legs = json.routes[0].legs;
      var nDirection_distance = 0;
      var dDirection_duration = 0;
      for (var i = 0; i < legs.length; i++) {
        nDirection_distance += parseFloat(legs[i].distance.value);
        dDirection_duration += parseFloat(legs[i].duration.value);
      }
      // console.log('nDirection_distance',nDirection_distance)
      var Distance = Math.round(Number(parseFloat((nDirection_distance) / 1000)).toFixed(1));
      var Duration = Number(parseFloat((dDirection_duration) / 60)).toFixed(0);
      //--------------------------------------------------------------------------
      //Exchange Operations
      var Distance2 = 0;
      var Duration2 = 0;

     
      var TotalDistance = parseFloat(Distance) + parseFloat(Distance2);
      var TotalDuration = parseFloat(Duration) + parseFloat(Duration2);

      var result = {
        Distance: TotalDistance,
        Duration: TotalDuration
      }
      return result;
    },
    async CalcNeshanWithTraffic(origin, destination, destination2) {
      // check webservice neshan without traffic
      var parameter = "?type=car&origin=" + origin.latitude + ',' + origin.longitude;
      if (this.markerThree != '') {
        parameter += "&waypoints=" + destination.latitude + "," + destination.longitude + '&destination=' + destination2.latitude + ',' + destination2.longitude;
      } else {
        parameter += '&destination=' + destination.latitude + ',' + destination.longitude;
      }
      let responseWithTraffic = await fetch('https://api.neshan.org/v4/direction' + parameter, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Api-Key': 'service.aa478f35b58c41069acddbd60d5aec08',
        },
      });
      let json = await responseWithTraffic.json();

      this.directionDistance = Math.round((json.routes[0].legs[0].distance.value) / 1000);
      this.directionDuration = Math.round((json.routes[0].legs[0].duration.value) / 60);
      var legs = json.routes[0].legs;
      var nDirection_distance = 0;
      var dDirection_duration = 0;
      for (var i = 0; i < legs.length; i++) {
        nDirection_distance += parseFloat(legs[i].distance.value);
        dDirection_duration += parseFloat(legs[i].duration.value);
      }
      var Distance = Math.round(Number(parseFloat((nDirection_distance) / 1000)).toFixed(1));
      var Duration = Number(parseFloat((dDirection_duration) / 60)).toFixed(0);
      //------------------------------------------------------------------------
      //Exchange Operations
      var Distance2 = 0;
      var Duration2 = 0;
      var TotalDistance = parseFloat(Distance) + parseFloat(Distance2);
      var TotalDuration = parseFloat(Duration) + parseFloat(Duration2);
      var result = {
        Distance: TotalDistance,
        Duration: TotalDuration
      }
      return result;
    },

  },

};
</script>

<style scoped>
.TopInputShowType {
  height: 40px;
  width: 90%;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #d7d6d6;
  padding: 0 10px;
}

.ListShowToUser {
  padding: 0 26px 0 13px;
  overflow-y: scroll;
  height: 100%;
}

.ChildListShowToUser {
  text-align: right;
  margin-top: 15px;
  transition: .1s ease-in-out;
  border-bottom: 1px solid #ccc;
  padding: 12px 0px;
}

.ChildListShowToUser:hover {
  color: #00bc6e;
  cursor: pointer;
  transition: .1s ease-in-out;
}

.DivCloseButton {
  width: 100%;
  background: red;
  color: white;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
}

.divClassDivCloseButton {
  margin: auto;
  width: 90%;
  display: grid;
  grid-template-columns: 68% 30%;
  justify-content: space-between;
}

.divClassDivCloseButton1 {
  margin: auto;
  width: 90%;
  display: grid;
  grid-template-columns: 49% 49%;
  justify-content: space-between;
}

.loader {
  width: 30px;
  height: 30px;
  border: 5px dotted #ff0000;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 2s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.page-f {
  height: calc(100vh - 56px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.op-size {
  font-size: 13px;
}

.deli-price-box {
  border: 2px solid #f49b3e;
  padding: 6px 95px;
  font-size: 14px;
  box-shadow: 0 0 6px 2px #ccc;
  border-radius: 4px;
}

.location-btn {
  position: absolute;
  z-index: 400;
  right: 11px;
  font-size: 26px;
  color: rgb(104 108 121 / 81%);
  background: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 2.2;
}

.back-btn {
  position: absolute;
  z-index: 400;
  right: 19px;
  font-size: 26px;
  color: rgb(104 108 121 / 81%);
  background: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 1.9;
  top: 17px;

}

.address-inputs {
  position: absolute;
  z-index: 1000;
  text-align: center;
  line-height: 1.9;
  bottom: 1px;
  width: 100%;
  height: auto;

}

.bg-white {
  background-color: white;
  box-shadow: 0 0 4px 0px #9f8e8e;
}

.LocS1 {
  bottom: 110px;
}

.LocS2 {
  bottom: 180px;
}

.LocS3 {
  bottom: 210px;
}

.LocS4 {
  bottom: 220px;
}

.LocS5 {
  bottom: 275px;
}
</style>